import app from 'firebase';
import 'firebase/auth';


const config = {
    apiKey: "AIzaSyBOERXw4dWDK4Jjbx7LVkc7rzd9YQ3YPJE",
    authDomain: "bnksistemimobile.firebaseapp.com",
    databaseURL: "https://bnksistemimobile.firebaseio.com",
    projectId: "bnksistemimobile",
    storageBucket: "bnksistemimobile.appspot.com",
    messagingSenderId: ""
};

class Firebase{
    constructor() {
        if (!app.apps.length) {
            app.initializeApp(config);
        }
        this.auth = app.auth();
        this.db = app.firestore()
        this.sto = app.storage();
    }
}
export default Firebase;